import Layout from "../../hocs/Layout";
import { useParams, Navigate, Link } from "react-router-dom";
import { useState } from "react";
import { connect } from "react-redux";
import { activate } from "../../redux/actions/auth";
import { InfinitySpin } from "react-loader-spinner";
import { setAlert } from "../../redux/actions/alert";

const Activate = ({ activate, loading, setAlert }) => {
  const params = useParams();
  const [activated, setActivated] = useState(false);

  const activate_account = async () => {
    const uid = params.uid;
    const token = params.token;

    const result = await activate(uid, token);

    if (result.status === 204) {
      setActivated(true);
    } else if (
      result.status === 403 &&
      result.data.detail === "Stale token for given user."
    ) {
      console.error("Validation errors:", result.data);
      setAlert(
        "Invalid token. Please request a new activation link.",
        "red"
      );
    } else {
      setAlert(`Error: ${result.data.detail}`, "red");
    }
  };

  if (activated && !loading) return <Navigate to="/login" />;

  return (
    <Layout>
    <div className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8 bg-white">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Activate your account to enjoy our services
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Or{" "}
          <Link
            to="/resend_activation"
            className="font-medium text-emerald-600 hover:text-emerald-500"
          >
            Resend activation link
          </Link>
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        {/* Card con fondo blanco y extra padding */}
        <div className="py-8 px-10 shadow sm:rounded-lg sm:px-10 bg-white">
          {loading ? (
            <button
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-emerald-600"
              disabled
            >
              <InfinitySpin color="#fff" width={20} height={20} />
            </button>
          ) : (
            <button
              onClick={activate_account}
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-emerald-600 hover:bg-emerald-700"
            >
              Activate Account
            </button>
          )}
        </div>
      </div>
    </div>
  </Layout>
  );
};

const mapStateToProps = (state) => ({
  loading: state.Auth.loading,
});

export default connect(mapStateToProps, {
  activate,
  setAlert,
})(Activate);
